import Box from "@mui/material/Box";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import { Link, useLocation } from "react-router-dom";
import { menuItems } from "./menu";

function SideNav() {
  const location = useLocation();

  return (
    <Box
      sx={{
        // boxShadow: "0px 6px 16px #0000001A",
        width: "320px",
        height: "100vh",
        overflowY: "auto",
        overflowX: "hidden",
        position: "fixed",
        backgroundColor: "#1A1A1A", 
        color: "white", 
        padding: "15px",
      }}
    >
      <Box mt={8}>
        <List>
          {menuItems.map((item, index) => (
            <Link
              to={item.path}
              key={item.title || index}
              style={{ textDecoration: "none", color: "inherit" }} 
            >
              <ListItemButton
                selected={location.pathname.startsWith(item.path)}
                sx={{
                  "&.Mui-selected": {
                    background: "#363636", 
                    borderRadius: "5px",
                  },
                  "&.Mui-selected:hover": {
                    background: "#363636", 
                  },
                  "&:hover": {
                    background: "#363636", 
                    borderRadius: "5px", 
                  },
                  display: "flex",
                  alignItems: "center",
                  padding: "8px",
                  marginTop: "12px",
                }}
              >
                <ListItemIcon>
                  <Box
                    sx={{
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    <img
                      src={item.icon}
                      alt={`${item.title} icon`}
                      width={20}
                      height={20}
                    />
                  </Box>
                </ListItemIcon>
                <ListItemText
                  primary={
                    <Typography
                      variant="h6" 
                      color="inherit" 
                      fontSize="14.5px" 
                      textAlign="left"
                    >
                      {item?.title}
                    </Typography>
                  }
                />
              </ListItemButton>
            </Link>
          ))}
        </List>
      </Box>
    </Box>
  );
}
export default SideNav;
